import React, { useState } from 'react';
import { connect } from 'react-redux';
import { selectHasPushError } from '@ff-os/pdp-shared-redux/slices/snapshotSlice';
import { Cell } from '@ff-os/shared-react/components/grid/Cell';
import { Grid } from '@ff-os/shared-react/components/grid/Grid';
import { WindowStackItem } from '@ff-os/shared-react/context/window-stack/WindowStackItem';
import { selectAllGroups } from '@ff-scene-plugins/photo-prints-redux/slices/groupsSlice';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import { selectIsAnyGroupNotEmpty } from '../../_redux-groups';
import { ChangeVariantWindow } from '../change-variant-window/ChangeVariantWindow';
import { AddGroupButtonMobile } from './AddGroupButtonMobile';
import { PhotoPrintsGroupPreview } from './photo-print-group-preview/PhotoPrintsGroupPreview';

const _PhotoPrintGroupsList = ({
    groups, isAnyGroupNotEmpty
}: Props) => {

    const [isOpen, setOpen] = useState(false);

    return (
        <Grid direction='column' gap='m' align='stretch'>
            {groups.map(g => (
                <Cell key={g.id}>
                    <PhotoPrintsGroupPreview
                        groupId={g.id}
                        variantId={g.variantId} />
                </Cell>
            ))}

            {isAnyGroupNotEmpty && (
                <Cell>
                    <AddGroupButtonMobile onClick={() => setOpen(true)} />
                </Cell>
            )}

            {isOpen && (
                <WindowStackItem>
                    <ChangeVariantWindow withUploader close={() => setOpen(false)} />
                </WindowStackItem>
            )}
        </Grid>
    );
};

type Props = {
    groups: PhotoPrintsJson.Group[];
    isAnyGroupNotEmpty: boolean;
    hasPushError: boolean;
};

const mapStateToProps = (state: PhotoPrintsPdpState) => ({
    groups: selectAllGroups(state),
    isAnyGroupNotEmpty: selectIsAnyGroupNotEmpty(state),
    hasPushError: selectHasPushError(state)
});

export const PhotoPrintGroupsList = connect(
    mapStateToProps
)(_PhotoPrintGroupsList);